const init = () => {
  const el = document.getElementById('RecipeSearchResults');

  if (!el || !el.dataset.predictiveUrl) {
    return;
  }

  fetch(el.dataset.predictiveUrl)
    .then((response) => response.text())
    .then((text) => {
      const cards = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('.metaobject-search-results');

      if (!cards) {
        return;
      }

        el.appendChild(cards);
        el.closest('.recipe-search-results').hidden = false;
    });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
